<template>
	<div class="structure-list">
		<VRadioGroup
			v-model="radioGroup"
			class="w-100"
			column
			hide-details
			:label="label"
			:name="name"
		>
			<StructureItem
				v-for="(item, index) in (items.slice(0, maxItemsLoaded))"
				:key="item.value"
				:checked="item.value === radioGroup"
				:group-name="name"
				:item="item"
				:option-name="`${name}-item-${index}`"
				@select="selectItem(item.value)"
			/>
		</VRadioGroup>

		<div class="d-flex justify-center">
			<AmeliproBtn
				v-if="items.length > maxItemsLoaded ? true : false"
				class="text-none"
				hover-underline
				text
				@click="loadMore"
			>
				{{ locales.loadMore }}

				<template #icon>
					{{ chevronDown }}
				</template>
			</AmeliproBtn>
		</div>
	</div>
</template>

<script setup lang="ts">
	import { PropType, computed, nextTick, ref } from 'vue';
	import AmeliproBtn from '../AmeliproBtn/AmeliproBtn.vue';
	import { Structure } from '../StructureItem/types';
	import StructureItem from '../StructureItem';
	import { locales } from './locales';
	import { mdiChevronDown } from '@mdi/js';

	const props = defineProps({
		hiddenLabel: {
			type: Boolean,
			default: false,
		},
		items: {
			type: Array as PropType<Structure[]>,
			required: true,
		},
		label: {
			type: String,
			required: true,
		},
		maxItemsLoadedDefault: {
			type: Number,
			default: 5,
		},
		name: {
			type: String,
			required: true,
		},
		value: {
			type: String,
			default: undefined,
		},
	});

	const chevronDown = mdiChevronDown;
	const maxItemsLoaded = ref(props.maxItemsLoadedDefault);

	const emit = defineEmits(['input']);
	const radioGroup = computed({
		get() {
			return props.value;
		},
		set(value: string | undefined) {
			emit('input', value);
		},
	});

	const selectItem = async(value: string): Promise<void> => {
		radioGroup.value = value;
		await nextTick();
	};

	const loadMore = (): void => {
		if (maxItemsLoaded.value <= props.items.length) {
			const itemToFocus = maxItemsLoaded.value - 1;
			maxItemsLoaded.value = props.items.length;
			const idToFocus = `${props.name}-item-${itemToFocus}`;
			document.getElementById(idToFocus)?.focus();
			const successAlert = document.createElement('p');
			successAlert.textContent = 'Les éléments on bien été chargés.';
			successAlert.setAttribute('role', 'success');
		}
	};
</script>
